<div class='flex flex-col md:flex-row pt-5 gap-4'>
  <div class='flex-1 flex flex-col gap-4'>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[170px] flex flex-col'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/drkninja.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>DrkNinja</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@drkninja</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-2.5 line-clamp-3'>I just wanted to give you my dearest thanks for this app! It has changed the way I consume anime, and honestly it's almost entirely perfect. 9.5/10 would and have recommended.</p>
    </div>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[170px] flex flex-col mb-0'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/jomujomujomu.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>jomujomujomu</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@jomujomujomu</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-2.5 line-clamp-3'>Thank you so much for this! I prefer the quality on torrents but prefer the convenience of streaming.</p>
    </div>
  </div>
  <div class='flex-1 flex flex-col gap-4'>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[190px] flex flex-col'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/avatar_default_6.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>Aralakh</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@Aralakh</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-3.5 line-clamp-5'>Whoa! This is my first time hearing about this app, awesome work. I love that you have the option to turn off English subs! I've been trying to find a site with current anime that doesn't have English subs or where one can turn on Japanese subs, this helps tremendously. Thank you!</p>
    </div>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[190px] flex flex-col mb-0'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/avatar_default_2.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>kwokinator</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@kwokinator</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-3.5 line-clamp-5'>Great app! Having a convenient app like this might actually swing me from binge watching after every season to watching weekly because I'm just too damn lazy to keep downloading new episodes every week for multiple shows instead of one big batch.</p>
    </div>
  </div>
  <div class='flex-1 flex flex-col gap-4'>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[170px] flex flex-col'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/alpharights.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>alpharights</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@alpharights</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-2.5 line-clamp-3'>Much easier for me to just open the app instead of having to type it in the search bar. Really glad this was made.</p>
    </div>
    <div class='bg-neutral-950 p-6 rounded-lg shadow min-h-[170px] flex flex-col mb-0'>
      <div class='flex flex-row text-white items-center pb-1.5'>
        <img src='/avatar_default_0.webp' class='rounded-full size-10 mr-5 object-cover' alt='pfp' />
        <div>
          <h4 class='text-lg font-bold m-0'>jtipt</h4>
          <p class='leading-normal text-xs text-muted-foreground m-0'>@jtipt</p>
        </div>
      </div>
      <p class='leading-normal text-sm text-muted-foreground m-0 pt-2.5 line-clamp-3'>This is quite an amazing app I'm liking it quite a lot. Probably gonna use this for all seasonal anime watching.</p>
    </div>
  </div>
</div>
